const state = {
  show: false,
  taxi: null,
};

const mutations = {
  setShow(state, isShow) {
    state.show = isShow;
  },

  setTaxi(state, taxi) {
    state.taxi = taxi;
  },
};

const actions = {};

const getters = {
  show(state) {
    return state.show;
  },

  taxi(state) {
    return state.taxi;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
